<div class="library" #library>
  @if (uploader.queue.length === 0) {
    <div
      class="library-container"
      celoFileDrop
      [uploader]="uploader"
      (fileOver)="dropZoneState($event)"
      (filesDropped)="handleDrop($event)"
      [ngClass]="{ valid: dropZoneActive === 'valid' }"
    >
      <div class="drop-highlight">
        <div>
          <i class="material-icons icon-xxl">cloud_upload</i>
          <div>UPLOAD</div>
        </div>
      </div>
      <div class="library-tools" #tools>
        <div class="search-bar">
          <div class="topbar-input">
            <app-celo-topbar-search-input
              [placeholder]="'Search by Patient ID or Patient Name'"
              (doSearch)="queryChange($event)"
            >
            </app-celo-topbar-search-input>
          </div>
        </div>
        <div class="get-app-box font-14 celo-cursor-pointer" (click)="app()">
          <div>
            Videos can be uploaded on the
            <span class="celo-link">Celo mobile app</span>
          </div>
        </div>
        <div class="drop-zone">
          <app-drop-zone
            [type]="'media files'"
            [formats]="['jpg', 'png']"
            [uploader]="uploader"
          ></app-drop-zone>
        </div>
        <div class="toolbar">
          <app-library-secondbar-toolbar
            [pageName]="'Media'"
            [singleFileId]="
              selected && selected.length === 1 && selected[0].id
                ? selected[0].id
                : ''
            "
            [singleFileName]="
              'Patient Photo.' +
              (selected && selected[0] && selected[0].mediaType === 'Photo'
                ? 'jpeg'
                : 'mp4')
            "
            [singleFileType]="'media'"
            [selectedFileCount]="selected.length"
            [hideExportToClinicalRecord]="false"
          >
          </app-library-secondbar-toolbar>
        </div>
      </div>
      <div
        data-testid="library-media-results"
        [attr.aria-busy]="loading"
        class="library-list"
        [style.height.px]="library.offsetHeight - tools.offsetHeight"
      >
        @if (loading) {
          <app-empty-state [isLoading]="true" [message]="'LOADING'">
          </app-empty-state>
        }
        @if (length === 0 && !loading) {
          <div>
            @if (!searchTerm) {
              <app-empty-state
                [title]="'Patient photos secure and separate from your own'"
                [message]="'Safely capture photos using the Celo Camera and keep them separate from your personal camera roll.'"
                [isEmpty]="true"
                [image]="'empty_states/empty-state-photos.svg'"
              ></app-empty-state>
            }
            @if (searchTerm) {
              <app-empty-state
                [title]="'No results found'"
                [message]="'Try searching by Patient ID or Patient Name'"
                [isEmpty]="true"
                [image]="'no-results-found-directory-v2.svg'"
              ></app-empty-state>
            }
          </div>
        }
        <app-media-list
          [searchQuery]="searchTerm"
          (selsectionChange)="selsectionChange($event)"
          (length)="length = $event; loading = false"
          [maxSelectionSize]="8"
        ></app-media-list>
      </div>
    </div>
  }

  @if (uploader.queue.length !== 0) {
    <div>
      <app-file-upload-preview
        (closeMe)="closeUpload()"
        [type]="'Photos'"
        [isInSecureLibrary]="true"
        [uploader]="uploader"
      >
      </app-file-upload-preview>
    </div>
  }
</div>
